import React from "react";
// import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import HowIts from "./components/HowIts";
import Effortless from "./components/Effortless";
import Recharge from "./components/Recharge";
import PaymentRecharge from "./components/PaymentRecharge";
import FAQ from "./components/FAQ";
// import Footer from "./components/Footer";

const Home = () => {
  return (
    <div>
      <HeroSection />
      <HowIts />
      <Effortless />
      <Recharge />
      <PaymentRecharge />
      <FAQ />
    </div>
  );
};

export default Home;
